import {
  HeartIcon,
  MagnifyingGlassIcon,
  UserCircleIcon,
  HomeIcon,
  ArrowUturnLeftIcon
} from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { PathName } from "routers/types";
import MenuBar from "shared/MenuBar/MenuBar";

interface NavItem {
  name: string;
  link?: PathName;
  icon: any;
  action?: () => void;
}

const FooterNav = () => {
  const location = useLocation();
  const [navItems, setNavItems] = useState<NavItem[]>([]);

  useEffect(() => {
    const loggedIn = sessionStorage.getItem("user_login");
    const updatedNav: NavItem[] = [
      ...(location.pathname !== "/" ? [
        {
          name: "Volver",
          icon: ArrowUturnLeftIcon,
          action: () => {window.history.back(); sessionStorage.removeItem("dates_adjusted");},
        }
      ] : []), // Solo agregar "Volver" si no estamos en la home
      {
        name: "Inicio",
        link: "/",
        icon: HomeIcon,
      },
      {
        name: loggedIn === "true" ? "Mis reservas" : "Ingresar",
        link: loggedIn === "true" ? "/account-savelists" : "/login",
        icon: UserCircleIcon,
      },
      {
        name: "Menu",
        icon: MenuBar,
      },
    ];
    setNavItems(updatedNav);
  }, [location.pathname]);

  const semaphore = sessionStorage.getItem("semaphore");
  const getAvatarColor = (semaphore: number) => {
    switch (semaphore) {
      case 0:
        return "text-red-500";
      case 1:
        return "text-yellow-500";
      case 2:
        return "text-blue-500";
      default:
        return "text-black-500";
    }
  };

  return (
    <div className="FooterNav p-2 bg-white dark:bg-neutral-800 border-t border-neutral-300 dark:border-neutral-700 fixed bottom-0 left-0 w-full z-50">
      <div className="w-full max-w-lg flex justify-around mx-auto text-sm text-center ">
        {/* MENU */}
        {navItems.map((item, index) => {
          const active = location.pathname === item.link;
          return item.link ? (
            <Link
              key={index}
              to={item.link}
              className={`flex flex-col items-center justify-between text-neutral-500 dark:text-neutral-300/90 ${
                active ? "text-neutral-900 dark:text-neutral-100" : ""
              }`}
            >
              <item.icon
                className={`w-6 h-6 ${
                  item.name === "Mis reservas" ? getAvatarColor(Number(semaphore)) : ""
                } ${active && item.name !== "Mis reservas" ? "text-blue-600" : ""}`}
              />
              <span className="text-[11px] leading-none mt-1">{item.name}</span>
            </Link>
          ) : (
            <div
              key={index}
              className={`flex flex-col items-center justify-between text-neutral-500 dark:text-neutral-300/90 ${
                active ? "text-neutral-900 dark:text-neutral-100" : ""
              }`}
              onClick={item.action} // Se ejecuta la acción del ítem
            >
              <item.icon className="w-6 h-6" />
              <span className="text-[11px] leading-none mt-1">{item.name}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FooterNav;
